/*!
 * Copyright © 2022. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Injectable } from '@angular/core';
import { isStringNullOrEmpty } from '../../../../utils';
import { LocalStorageService } from '../../../shared/services';
import { EDriverType, IGetVehicleJourneyResponse, IGetVehicleReplayPlotsResponse } from '../../models';
import { IReplayMockDataService } from './replay-mock-data.service.interface';

@Injectable()
export class ReplayMockDataService implements IReplayMockDataService {
  // Set the localstorage (not using cookies as replay data will typically exceed the size limit)
  // with the response values wanted for each replay call, this service will handle changing vehicle ids
  constructor(private readonly _localStorage: LocalStorageService) {}

  public mockReplayPlotsIfValueExists(response: IGetVehicleReplayPlotsResponse): IGetVehicleReplayPlotsResponse {
    // window.localStorage.setItem('replay_plot_mock','')
    const localStorageValue = this._localStorage.getItem('replay_plot_mock');
    if (isStringNullOrEmpty(localStorageValue)) {
      return response;
    }

    try {
      const mockData = JSON.parse(localStorageValue) as IGetVehicleReplayPlotsResponse;
      return mockData;
    } catch (error) {
      return response;
    }
  }

  public mockReplayJourneyIfValueExists(response: IGetVehicleJourneyResponse, vehicleId: number): IGetVehicleJourneyResponse {
    // window.localStorage.setItem('replay_journey_mock','')
    const localStorageValue = this._localStorage.getItem('replay_journey_mock');

    // Optional driver id to mock into segments
    // window.localStorage.setItem('replay_journey_mock_driverId','')
    const localStorageDriverId = this._localStorage.getItem('replay_journey_mock_driverId');
    if (isStringNullOrEmpty(localStorageValue)) {
      return response;
    }

    try {
      const mockData = JSON.parse(localStorageValue) as IGetVehicleJourneyResponse;

      // Replace mocked vehicle id with actual id
      mockData.centricities.forEach(centricity => {
        centricity.vehicles.forEach(vehicle => {
          vehicle.id = vehicleId;
          vehicle.centricities.forEach(vehicleCentricity => {
            vehicleCentricity.segments.forEach(segment => {
              if (!isStringNullOrEmpty(localStorageDriverId)) {
                segment.driver.id = parseInt(localStorageDriverId, 10);
              } else {
                segment.driver.$type = EDriverType.UnknownDriver;
              }
            });
          });
        });
      });

      return mockData;
    } catch (error) {
      return response;
    }
  }
}
